const defaultState = {
  section: null
};

export default defaultState;
